import useGetTask from '@/api/queries/tasks/useGetTask';
import CustomFieldTaskView from '@/ui/components/CustomFieldTaskView/CustomFieldTaskView';
import { Modal, ModalProps } from '@payaca/ambrosia';

import { Task } from '@payaca/types/taskTypes';
import { FC } from 'react';

export type TProps = { taskId: Task['id'] } & Pick<
  ModalProps,
  'isOpen' | 'onClose'
>;

const CustomFieldTaskViewModal: FC<TProps> = (props) => {
  const { isOpen, onClose, taskId } = props;

  const { task } = useGetTask(taskId);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Task - ${task?.name}`}>
      <Modal.Body>
        <CustomFieldTaskView taskId={taskId} />
      </Modal.Body>
    </Modal>
  );
};

export default CustomFieldTaskViewModal;
